<template>
    <DriversOverTimeChart
        :title="t('analytics.insights.attrition.title', { label: getLabel('attrition_risk').value })"
        :subtitle="t('analytics.insights.attrition.subtitle')"
        :over-time-subtitle-prefix="t('analytics.insights.attrition.overTimePrefix')"
        :drivers="drivers"
        :is-loading="isFetchingFilters || isFetching" />
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import DriversOverTimeChart from "~vue/ClientAnalytics/DriversOverTimeChart.vue";
import { getURLParamsFromFilters } from "~vue/ClientAnalytics/filters/helpers";
import type { DriversOverTimeResponse, SelectedFilters } from "~vue/ClientAnalytics/types";
import { useCustomLabels } from "~vue/composables/useCustomLabels";
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const getLabel = useCustomLabels("client_analytics.insights");

const { filters = {}, isFetchingFilters = false } = defineProps<{
    filters?: SelectedFilters;
    isFetchingFilters?: boolean;
}>();

const url = computed(() => {
    const params = getURLParamsFromFilters(filters);
    return `/api/client-analytics/attrition-drivers/?` + params.toString();
});

const { data, isFetching, statusCode } = useFetch(url, { immediate: true, refetch: true }).json<DriversOverTimeResponse>();

const emit = defineEmits<{ hasKAnonError: [hasError: boolean] }>();

watch(statusCode, (newStatusCode) => emit("hasKAnonError", newStatusCode === 451), { immediate: true });

const ATTRITION_COLORS = ["#D8B4FE", "#93C5FD", "#FED7AA", "#EA5198", "#A3E4A5", "#FFE08A"];

const drivers = computed(() => {
    if (!data.value || data.value.error) {
        return [];
    }
    return data.value.drivers.map((driver, index) => ({
        ...driver,
        // Note that colors are mapped here before any sorting in the chart component so that the
        // driver colors remain consistent regardless of their values.
        color: ATTRITION_COLORS[index % ATTRITION_COLORS.length],
    }));
});
</script>
